export default __webpack_public_path__ + "static/BCI_logo-536326039d1681c36f362a4674cd23a2.png";